import { MediaItem } from "./media-upload";

/**
 * Convert media items to the format expected by the form
 * @param media - The media items to convert
 * @returns The converted media items
 */
export const convertMedia = (
  media: {
    key: string;
    mimeType: string;
    originalUrl: string;
    thumbnailUrl: string;
  }[]
): MediaItem[] => {
  return (
    media
      ?.filter((item) => item.originalUrl && item.thumbnailUrl)
      .map((item) => ({
        key: item.key,
        mimeType: item.mimeType,
        originalUrl: item.originalUrl,
        thumbnailUrl: item.thumbnailUrl,
      })) || []
  );
};

/**
 * Convert date strings to YYYY-MM-DD format for date inputs
 * @param dateString - The date string to convert
 * @returns The converted date string
 */
export const convertDateForInput = (dateString: string | null) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  return date.toISOString().split("T")[0];
};
